import { createApp } from 'vue'
import App from './pages/App.vue'
import router from './router'
import store from './store'
import { axios } from './utils/request'
import VueAxios from 'vue-axios'
import Antd from 'ant-design-vue';
import { fetchSiteInfo } from './storage/site_info'

const app = createApp(App)
app.use(router)
app.use(store)
app.use(VueAxios, axios)
app.use(Antd)

const initApp = async () => {
    // 应用初始化时获取站点信息
    await fetchSiteInfo();
    app.mount('#app');
};

initApp()
